import StatusBox from "../../../../../../common/components/atom/StatusBox/StatusBox";
import Table, {
  TableRow,
} from "../../../../../../common/components/molecule/Table/Table";
import { themeColorAppJs } from "../../../../../../styles/theme/themeColor";
import { UserRole, userRoles } from "../../../../../user/types/user.types";
import { UCTStatut } from "../../../../types/createUserLink.type";
import styles from "./CreateUserLinkListView.module.scss";

export interface CreateUserLinkItem {
  id: string;
  fristnameUser: string;
  lastnameUser: string;
  expiresIn: string;
  userRole: UserRole;
  status: UCTStatut;
  emailUser: string;
  onClick?: () => void;
  link?: string;
  actionBtnRender: () => JSX.Element;
  organizationNameRender: () => JSX.Element;
}

export interface CreateUserLinkListViewProps {
  content?: CreateUserLinkItem[];
  nbFound?: number;
}

/**
 * CreateUserLinkListView
 *
 * @returns
 */
export default function CreateUserLinkListView({
  content,
  nbFound
}: CreateUserLinkListViewProps) {
  const contentFormated: TableRow[] =
    content?.map((item) => {
      return {
        id: item.id,
        onRowClick: () => item.onClick && item.onClick(),
        data: [
          item.emailUser,
         
          roleConverter(item.userRole),
          () => item.organizationNameRender(),
          () => statusConverter(item.status),
          () => item.actionBtnRender(),
        ],
      };
    }) || [];
  return (
    <div className={styles["global-container"]}>
      <Table
        headerTitle={["Email",  "Rôle", "Organisation", "Statut"]}
        bodyData={contentFormated}
        emptyMessage="Aucune invitation trouvée"
        NbFoundViewProps={{
          nbFound: nbFound,
          itemName: { single: "invitation trouvé", plurial: "invitations trouvées" },
        }}
    
      />
    </div>
  );
}

const statusConverter = (status: UCTStatut) => {
  const size = { width: "80px", height: "20px", font: "0.8rem" };
  switch (status) {
    case "ACTIVATED":
      return (
        <StatusBox
          size={size}
          color={{
            text: themeColorAppJs.green.dark,
            background: themeColorAppJs.green.light,
          }}
        >
          Activé
        </StatusBox>
      );
    case "DESACTIVATED":
      return (
        <StatusBox
          size={size}
          color={{
            text: themeColorAppJs.red.dark,
            background: themeColorAppJs.red.light,
          }}
        >
          Désactivé
        </StatusBox>
      );
      case "CONSUMMATE": 
      return (
        <StatusBox
          size={size}
          color={{
            text: themeColorAppJs.gray.dark,
            background: themeColorAppJs.gray.light,
          }}
        >
          Consommé
        </StatusBox>
      );
    default:
      return (
        <StatusBox
          size={size}
          color={{
            text: themeColorAppJs.gray.dark,
            background: themeColorAppJs.gray.light,
          }}
        >
          {status}
        </StatusBox>
      );
  }
};

const roleConverter = (role: UserRole) : string => {
  switch (role) {
    case userRoles.SUPER_ADMIN:
      return "Super Administrateur";
    case userRoles.ADMIN:
      return "Administrateur";
    case userRoles.USER:
      return "Utilisateur";
    default:
      return "Inconnu";
  }
}
